import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import Box from '../ui/Box';

import moment from 'moment';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; 
var help = Helper;

export default class ManageSmartLockCards extends Component {

  constructor(props) {
    super(props);
    this.state = {
      role:true,
      all_devices: [],
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 1000,
      card_id: '',
      addCardDialogOpen: false,
      startDate : moment(new Date().getTime()).format("MMM DD, YYYY HH:mm"),
      endDate : moment( new Date(Date.now() + 1000 * 60 * 60 * 24 * 7).getTime() ).format("MMM DD, YYYY HH:mm"),
      hotel_id : ls.getUserDetails().hotel_id,
      LIST_KEYCARDS: 47,
      ADD_CARD_INTENT: 48,
      DELETE_CARD_INTENT: 49,
      keycard_list: [],
      deleteConfirmDialogOpen: false,
      cardToDelete: null,
      timeRemaining: 60,
      timerActive: false,
      cardInputBuffer: '',
      showSuccess: false,
      isAddingCard: false,
      errorMessage: '',
      showError: false,
      showAddCardError: false,
      sortBy: 'hotel_room_no',
      sortDirection: 'asc',
      searchQuery: '',
      filteredDevices: [],
      startTimerid: null,
      readKeyPressInput: false
    }
  }
  maxItems = 10;
  componentDidMount() {
    this.getAllDevices();
  }
  
  onChangePage(e) {
    this.setState({
      activePage: e
    })
  }

  getAllDevices() {
    ds.getAllDevices((data) => {
      if (data && data.status == 1) {
        const devices = (data.data || []).filter((d) => d.device_type !== 'SMART_GATEWAY');
        this.setState({
          all_devices: devices,
          filteredDevices: devices,
          totalCount: devices.length
        }, this.filterAndSortDevices);
      }
    }, (err) => {
      console.log(err);
    })
  }
  
  componentWillUnmount() {
    if (this.state.startTimerid) {
      clearTimeout(this.state.startTimerid);
    }
    document.removeEventListener('keypress', this.handleKeyPress);
  }
  
  handleAddCardDialogOpen = (room) => {
    if (!room.check_out_time || new Date(room.check_out_time).getTime() < new Date().getTime()) {
      this.setState({
        showAddCardError: true
      })
      return;
    }
    
    this.setState({
      addCardDialogOpen: true,
      currentDevice: room,
      timeRemaining: 60,
      timerActive: true,
      cardInputBuffer: '',
      showSuccess: false
    }, () => {
      // Start timer
      this.startTimer();
      // Add keypress listener
      this.setState({ readKeyPressInput: true });
      document.addEventListener('keypress', this.handleKeyPress);
    });
  }
  
  startTimer = () => {
    let startTimerid = setTimeout(() => {
      this.setState(() => {
        // document.removeEventListener('keypress', this.handleKeyPress);
        return {
          timeRemaining: 0,
          timerActive: false,
          addCardDialogOpen: false,
          readKeyPressInput: false
        };
      });
    }, 60*1000);
    this.setState({ startTimerid : startTimerid }); 
  }

  handleAddCardCancel = () => {
    clearTimeout(this.state.startTimerid);
    // document.removeEventListener('keypress', this.handleKeyPress);
    this.setState({ 
      addCardDialogOpen: false,
      currentDevice: null,
      timerActive: false,
      cardInputBuffer: '',
      showSuccess: false,
      readKeyPressInput: false
    });
  }
  
  handleKeyPress = (event) => {
    if (!this.state.timerActive || this.state.showSuccess || this.state.isAddingCard || !this.state.readKeyPressInput) return;
  
    if (event.key === 'Enter') {
      if (this.state.cardInputBuffer.trim()) {
        clearTimeout(this.state.startTimerid);
        // document.removeEventListener('keypress', this.handleKeyPress);
        this.setState({ isAddingCard: true, readKeyPressInput : false }, () => {
          this.handleAddCardConfirm(this.state.cardInputBuffer);
        });
      }
      return;
    }
  
    this.setState(prevState => ({
      cardInputBuffer: prevState.cardInputBuffer + event.key
    }));
  }
  
  handleCardNumberChange = (event) => {
    this.setState({ card_id: event.target.value });
  }

  handleAddCardConfirm = (cardNumber) => {
    const { currentDevice } = this.state;
  
    let payload = {
      intent: this.state.ADD_CARD_INTENT,
      UDid: currentDevice.UDid,
      startDate: new Date(this.state.startDate).getTime(),
      endDate: new Date(currentDevice.check_out_time).getTime(),
      cardNumber: cardNumber,
      cardName: moment(new Date().getTime()).format('DD-MM-YYYY hh:mm A').toString(),
      addType: 2,
      date: new Date().getTime(),
      hotel_id: this.state.hotel_id
    };
  
    ds.postCardActionToLock(payload, 
      (response) => {
        if(response.cardId) {
          this.setState({ 
            isAddingCard: false,
            showSuccess: true,
            showError: false,
            errorMessage: ''
          }, () => {
            setTimeout(() => {
              this.setState({ 
                addCardDialogOpen: false,
                showSuccess: false,
                cardInputBuffer: ''
              });
            }, 2000);
          });
        } else {
          this.setState({ 
            isAddingCard: false,
            showSuccess: false,
            showError: true,
            errorMessage: 'Failed to add card. Please try again.',
            cardInputBuffer: ''
          }, () => {
            setTimeout(() => {
              this.setState({ 
                addCardDialogOpen: false,
                showError: false,
                errorMessage: ''
              });
            }, 3000);
          });
        }
      }, 
      (error) => {
        let errorMsg = 'Failed to add card. Please try again.';
        if (error.errmsg) {
          errorMsg = error.errmsg;
        }
        
        this.setState({ 
          isAddingCard: false,
          showSuccess: false,
          showError: true,
          errorMessage: errorMsg,
          cardInputBuffer: ''
        }, () => {
          setTimeout(() => {
            this.setState({ 
              addCardDialogOpen: false,
              showError: false,
              errorMessage: ''
            });
          }, 3000);
        });
      }
    );
  }

  handleAddCardCancel = () => {
    this.setState({ 
      addCardDialogOpen: false,
      currentDevice: null,
      card_id: '' 
    });
  }

  handleListCards = (lock) => {
    this.setState({ currentDevice: lock });
    ds.postCardActionToLock({
      intent: this.state.LIST_KEYCARDS,
      hotel_id: this.state.hotel_id,
      UDid: lock.UDid,
    },
    (data) => {
      this.setState({
        keycard_list: data.list,
        listCardsDialogOpen: true
      });
    },
    (err) => {
      console.log('Error fetching keycards', err);
    });
  }

  handleListCardsDialogClose = () => {
    this.setState({ 
      listCardsDialogOpen: false,
      keycard_list: []
    });
  }
  
  handleDeleteCardClick = (card_id) => {
    this.setState({
      deleteConfirmDialogOpen: true,
      cardToDelete: card_id
    });
  }

  handleDeleteCard = (card_id) => {
    let payload = {
      intent: this.state.DELETE_CARD_INTENT,
      UDid: currentDevice.UDid,
      cardId: card_id,
      deleteType: 2,
      date: new Date().getTime(),
      hotel_id: this.state.hotel_id
    };

    ds.postCardActionToLock(payload, 
      (response) => {
        console.log('Card added successfully', response);
        this.setState({ addCardDialogOpen: false });
      }, 
      (error) => {
        console.error('Card addition failed', error);
      }
    );
  }

  handleDeleteConfirm = () => {
    const { cardToDelete, currentDevice, hotel_id } = this.state;
    
    let payload = {
      intent: this.state.DELETE_CARD_INTENT,
      UDid: currentDevice.UDid,
      cardId: cardToDelete,
      deleteType: 2,
      date: new Date().getTime(),
      hotel_id: hotel_id
    };
  
    ds.postCardActionToLock(payload, 
      (response) => {
        // Remove the deleted card from the list
        const updatedCards = this.state.keycard_list.filter(
          card => card.cardId !== cardToDelete
        );
        this.setState({
          keycard_list: updatedCards,
          deleteConfirmDialogOpen: false,
          cardToDelete: null
        });
      }, 
      (error) => {
        console.error('Card deletion failed', error);
        this.setState({
          deleteConfirmDialogOpen: false,
          cardToDelete: null
        });
      }
    );
  }
  
  handleDeleteCancel = () => {
    this.setState({
      deleteConfirmDialogOpen: false,
      cardToDelete: null
    });
  }

  handleDeleteAddCardError = () => {
    this.setState({
      showAddCardError: false
    });
  }

  handleSort = (column) => {
    const { sortBy, sortDirection, filteredDevices } = this.state;
    
    // Toggle direction if same column, otherwise default to asc
    const newDirection = (sortBy === column) 
      ? (sortDirection === 'asc' ? 'desc' : 'asc')
      : 'asc';
  
    // Create a new sorted array
    const sortedDevices = [...filteredDevices].sort((a, b) => {
      let aValue = a[column] || '';
      let bValue = b[column] || '';
      
      // Convert to strings for comparison
      aValue = aValue.toString().toLowerCase();
      bValue = bValue.toString().toLowerCase();
      
      // Handle numeric room numbers
      if (column === 'hotel_room_no') {
        aValue = parseInt(aValue) || 0;
        bValue = parseInt(bValue) || 0;
        return newDirection === 'asc' ? aValue - bValue : bValue - aValue;
      }
      
      // String comparison
      if (newDirection === 'asc') {
        return aValue.localeCompare(bValue);
      }
      return bValue.localeCompare(aValue);
    });
  
    this.setState({
      sortBy: column,
      sortDirection: newDirection,
      filteredDevices: sortedDevices
    });
  };

  handleSearch = (event) => {
    this.setState({
      searchQuery: event.target.value
    }, this.filterAndSortDevices);
  };

  filterAndSortDevices = () => {
    const { all_devices, searchQuery, sortBy, sortDirection } = this.state;
    let filtered = [...all_devices];
    
    if (searchQuery) {
      filtered = filtered.filter(device => 
        device.hotel_room_no.toString().toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    
    filtered.sort((a, b) => {
      const aValue = a[sortBy] && a[sortBy].toString().toLowerCase() || '';
      const bValue = b[sortBy] && b[sortBy].toString().toLowerCase() || '';
      
      if (sortDirection === 'asc') {
        return aValue.localeCompare(bValue);
      } else {
        return bValue.localeCompare(aValue);
      }
    });
    
    this.setState({ filteredDevices: filtered });
  };

  render() {
    const addCardActions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleAddCardCancel}
      />,
      <FlatButton
        label="Add"
        primary={true}
        onClick={this.handleAddCardConfirm}
      />,
    ];

    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} />
    return (
      <div>
        <Dialog
          title="Unable to Add Card"
          actions={[
            <FlatButton
              label="OK"
              primary={true}
              onClick={this.handleDeleteAddCardError}
            />
          ]}
          modal={false}
          open={this.state.showAddCardError}
          onRequestClose={this.handleDeleteAddCardError}
        >
          This room has already checked out. Please check-in to add card.
        </Dialog>

        <Dialog
          // title="Add Card to Lock"
          actions={[
            <FlatButton
              label="Cancel"
              primary={true}
              onClick={this.handleAddCardCancel}
            />
          ]}
          modal={true}
          open={this.state.addCardDialogOpen}
          onRequestClose={this.handleAddCardCancel}
        >
          <div style={{ textAlign: 'center' }}>
            {this.state.isAddingCard ? (
              <div>
                <i className="material-icons" style={{ fontSize: '48px' }}>hourglass_empty</i>
                <p>Adding card...</p>
              </div>
            ) : this.state.showError ? (
              <div>
                <i 
                  className="material-icons" 
                  style={{ 
                    color: 'red', 
                    fontSize: '48px' 
                  }}
                >
                  error
                </i>
                <p style={{ color: 'red' }}>{this.state.errorMessage}</p>
              </div>
            ) : !this.state.showSuccess ? (
              <div>
                <img 
                  src="assets/images/RFID_reader.png" 
                  alt="RFID Reader"
                  style={{ 
                    maxWidth: '300px', 
                    margin: '2rem auto' 
                  }}
                />
                <p className="font-2rem">Please place your card on the reader</p>
              </div>
            ) : (
              <div>
                <i 
                  className="material-icons" 
                  style={{ 
                    color: 'green', 
                    fontSize: '48px' 
                  }}
                >
                  check_circle
                </i>
                <p>Card added successfully!</p>
              </div>
            )}
          </div>
        </Dialog>

        <Dialog
          title="Cards List"
          modal={false}
          open={!!this.state.listCardsDialogOpen}
          onRequestClose={this.handleListCardsDialogClose}
          autoScrollBodyContent={true}
        >
          <Table>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn>Card Name</TableHeaderColumn>
                <TableHeaderColumn>Card Number</TableHeaderColumn>
                <TableHeaderColumn>Action</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {this.state.keycard_list.length > 0 ? (
                this.state.keycard_list.map((card, index) => (
                  <TableRow key={index}>
                    <TableRowColumn>{card.cardName}</TableRowColumn>
                    <TableRowColumn>{card.cardNumber}</TableRowColumn>
                    <TableRowColumn>
                      <i 
                        className="nav-icon material-icons"
                        style={{ cursor: 'pointer', color: 'red' }}
                        onClick={() => this.handleDeleteCardClick(card.cardId)}
                      >
                        delete
                      </i>
                    </TableRowColumn>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableRowColumn colSpan={3} style={{ textAlign: 'center' }}>
                    No cards available
                  </TableRowColumn>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Dialog>

        <Dialog
          title="Confirm Delete"
          actions={[
            <FlatButton
              label="Cancel"
              primary={true}
              onClick={this.handleDeleteCancel}
            />,
            <FlatButton
              label="Delete"
              primary={true}
              onClick={this.handleDeleteConfirm}
            />
          ]}
          modal={false}
          open={this.state.deleteConfirmDialogOpen}
          onRequestClose={this.handleDeleteCancel}
        >
          Are you sure you want to delete this card?
        </Dialog>

        <Box header='All Rooms in the Hotel'>
          <TextField
            hintText="Search by room number"
            value={this.state.searchQuery}
            onChange={this.handleSearch}
            style={{ marginBottom: '20px' }}
          />
        
          <Table
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
            bodyStyle={{ minWidth: 680, overflowX: 'auto' }}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn 
                  tooltip="Room Number"
                  style={{ cursor: 'pointer', userSelect: 'none'}}
                  onClick={() => this.handleSort('hotel_room_no')}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => this.handleSort('hotel_room_no')}>
                    Room Number
                    {this.state.sortBy === 'hotel_room_no' && (
                      <i className="material-icons" style={{ marginLeft: '5px', fontSize: '18px' }}>
                        {this.state.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'}
                      </i>
                    )}
                  </div>
                </TableHeaderColumn>
                <TableHeaderColumn tooltip="Add card">Add Card</TableHeaderColumn>
                <TableHeaderColumn tooltip="List Cards">List Cards</TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              { this.state.filteredDevices.map((row, index) => (
                <TableRow key={index}>
                  <TableRowColumn style={{ overflow: 'visible' }}>
                    {row.hotel_room_no ? row.hotel_room_no : ''}
                  </TableRowColumn>

                  <TableRowColumn style={{ overflow: 'visible' }} >
                    <i className="nav-icon material-icons"
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.handleAddCardDialogOpen(row)}
                    >
                      add
                    </i>

                  </TableRowColumn>

                  <TableRowColumn style={{ overflow: 'visible' }}>
                    <i className="nav-icon material-icons"
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.handleListCards(row)}
                    >
                      dns
                    </i>
                  </TableRowColumn>
                </TableRow>
              ))}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TableRowColumn colSpan="7" style={{ textAlign: 'center' }}>

                </TableRowColumn>
                <TableRowColumn colSpan="3" style={{ textAlign: 'right' }}>
                  {/* {pagination} */}
                </TableRowColumn>
              </TableRow>
            </TableFooter>
          </Table>
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/smartLockCards/ManageSmartLockCards.js